import React from 'react';

const TiltHUD = ({ degree }) => {
  // Clamp degree between -90 and 90
  const clampedDegree = Math.max(-90, Math.min(90, degree || 0)) ;
  
  // Calculate rotation for icon (positive tilt = rotate up)
  const rotation = clampedDegree;

  return (
    <div className="flex items-center gap-2 rounded bg-black/70 px-3 py-2 text-xs">
      {/* Rotating arrow icon */}
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        style={{
          transform: `rotate(${-(rotation-90)}deg)`,
          transition: 'transform 0.3s ease',
          filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.8))',
        }}
      >
        <path
          d="M12 4 L12 20 M12 4 L8 8 M12 4 L16 8"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      
      {/* Degree value */}
      <span
        className="font-bold text-white"
        style={{
          textShadow: `
            -1px -1px 0 black,
            1px -1px 0 black,
            -1px  1px 0 black,
            1px  1px 0 black
          `,
        }}
      >
        {clampedDegree.toFixed(1)}°
      </span>
    </div>
  );
};

export default TiltHUD;
